<template>
    <div class="newMass" v-loading="loadingData">
        <div class="mass-channel-conntainer">
            <div class="channel-label">选择群发渠道：</div>
            <el-radio-group v-model="channel" class="channal-list" @change="changeChannel">
                <el-radio v-for="(item, index) in channelArr" :key="index" :label="item.sourceQk">{{item.label}}
                </el-radio>
            </el-radio-group>
        </div>
        <div style="color: red;padding-top: 10px;font-size: 12px;" v-if="channel != 3">注意:{{channel == 1 ? '公众号'
            :'小程序'}}仅支持24小时内访问过的访客,超过24小时未进行对话的访客暂不支持群发
        </div>
        <div class="dialog-container">
            <div class="visitor-list-container">
                <div class="tab-btn-wraper">
                    <div class="tab-btn-container">
                        <span class="tab-btn" :class="tabChange === 'visitor' ? 'activeBtn' : ''"
                              @click="tabChangeHandler('visitor')">所有访客</span>
                        <span class="tab-btn" :class="tabChange === 'tag' ? 'activeBtn' : ''"
                              @click="tabChangeHandler('tag')">按标签</span>
                    </div>
                </div>
                <div class="list-wrapper" v-if="tabChange === 'visitor'">
                    <div class="checkAll-btn">
                        <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
                                     v-if="visitorData.length > 0"
                                     :disabled="visitorData.length === 0">
                            全选
                        </el-checkbox>
                    </div>
                    <el-checkbox-group class="checkbox-list" v-model="checkedVisotors"
                                       @change="handleCheckedVisitorChange">
                        <el-checkbox class="visitor-list-item" v-for="(item, index) in visitorData"
                                     :label="item.visitorId"
                                     :key="item.visitorId">
                            <div class="visitor-info-container">
                                <div class="visitor-avatar">
                                    <img :src="avatarX(item.visitorHeadimg)" alt="">
                                </div>
                                <div class="visitor-nickname">{{item.visitorName}}</div>
                            </div>
                        </el-checkbox>
                    </el-checkbox-group>
                    <div class="loadmore-data">
                        <span class="hava-more" v-if="!isFinished" @click.stop="loadMoreData">加载更多</span>
                        <span v-else>暂无更多数据</span>
                    </div>
                </div>
                <div class="list-wrapper tag-wrapper" v-if="tabChange === 'tag'">
                    <el-collapse v-model="activeNames" @change="collapseChange" accordion>
                        <el-collapse-item :title="tagItem.text" :name="tagItem.id" :key="'tag'+tagItem.id"
                                          v-for="(tagItem, index) in tagList" class="tagItem" :class="tagItem.children.length == 0 ? 'pd0' : ''">
                            <div class="checkAll-btn" style="padding-left: 0;" v-if="tagItem.children.length > 0">
                                <el-checkbox v-model="tagItem.checkAll" @change="handleTagCheckAllChange"
                                             :disabled="tagItem.children.length === 0">
                                    全选
                                </el-checkbox>
                            </div>
                            <el-checkbox-group class="checkbox-list" v-model="checkedVisotors"
                                               @change="handleCheckedTagVisitorChange">
                                <el-checkbox class="visitor-list-item" v-for="(item, index) in tagItem.children"
                                             :label="item.visitorId"
                                             v-if="tagItem.children.length > 0"
                                             :key="item.visitorId">
                                    <div class="visitor-info-container">
                                        <div class="visitor-avatar">
                                            <img :src="avatarX(item.visitorHeadimg)" alt="">
                                        </div>
                                        <div class="visitor-nickname" :title="item.visitorName">{{item.visitorName}}</div>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="loadmore-data">
                                <span class="hava-more" v-if="!tagItem.noMoreData"
                                      @click.stop="loadMoreVisitorData(tagItem.id, tagItem.pageNum)">加载更多访客</span>
                                <span v-else>暂无更多访客数据</span>
                            </div>
                        </el-collapse-item>
                        <div style="text-align: center;font-size: 12px;padding: 8px 0;box-sizing: border-box;">
                            <div v-if="allTags">暂无更多标签数据</div>
                            <div v-else style="cursor: pointer;" @click="loadMoreTag">加载标签数据</div>
                        </div>
                    </el-collapse>

                </div>
            </div>
            <div class="visitor-chose-container clearfix">
                <div v-if="checkedVisotorsItem.length > 0" class="choose-item"
                     v-for="(item, index) in checkedVisotorsItem" :key="'choose'+ index">
                    <div class="choose-avatar"><img :src="avatarX(item.visitorHeadimg)" alt=""></div>
                    <div class="choose-nickname" :title="item.visitorName">{{item.visitorName}}</div>
                </div>
                <div v-else>暂无选中数据</div>
                <!--                <div v-for="(item, index) in checkedVisotorsItem" :key="'choose'+ index">123</div>-->
            </div>
            <div class="visitor-sendMsg-contianer">
                <div class="content-container">
                    <div class="text-msg">
                        <vue-emoji class="text-emoji" @selectedEmoji="selectEmoji" @click.native="TplClickEmoji($event)"
                                   v-show="showEmoji"></vue-emoji>
                        <div>文本消息：</div>
                        <div>
                            <svg-icon class="chat-bar-icon" @click.native.stop="clickEmoji"
                                      icon-class="emoji-icon"></svg-icon>
                        </div>
                        <el-input
                                class="textMsgInput"
                                ref="textContentInput"
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="textContent"
                        >
                        </el-input>
                    </div>
                    <div class="image-msg">
                        <div>图片消息：</div>
                        <div class="img-wraper" v-if="imgContent.length > 0">
                            <i class="el-icon-circle-close del-btn" @click="delImage"></i>
                            <img :src="imgContent" alt="">
                        </div>
                        <div v-else style="height: 150px;height: 150px;margin: 0 auto;line-height: 150px;">
                            <span class="choose-image" @click="chooseImage">选择图片</span>
                            <input type="file" ref="imageFileChange" @change="imageFileChange" v-show="false">
                        </div>
                    </div>
                </div>
                <div class="send-operation">
                    <span class="wl-btn" @click="sendMassMsg">发送</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import avatar0 from '@/assets/images/client_avatar_empty.png'
    import avatar1 from '@/assets/images/client_avatar1.png'
    import avatar2 from '@/assets/images/client_avatar2.png'
    import avatar3 from '@/assets/images/client_avatar3.png'
    import avatar4 from '@/assets/images/client_avatar4.png'
    import avatar5 from '@/assets/images/client_avatar5.png'
    import avatar6 from '@/assets/images/client_avatar6.png'
    import avatar7 from '@/assets/images/client_avatar7.png'
    import emojiData from '@/libs/emoji/emoji-data'

    import VueEmoji from '@/libs/emoji/Emoji'

    export default {
        props: ['dialogVisible'],
        name: "newMass",
        data() {
            return {
                channel: '3',
                tabChange: 'visitor',
                channelArr: [
                    {label: '网站', sourceQk: '3'},
                    {label: '公众号', sourceQk: '1'},
                    {label: '小程序', sourceQk: '2'},
                ],
                showEmoji: false,
                checkAll: false,
                checkedVisotors: [],
                checkedVisotorsItem: [],
                visitorData: [],
                isFinished: true,
                loadingData: false,
                canScroll: true,
                pageNum: 1,
                pageSize: 10,
                textContent: '',
                imgContent: '',
                accept: 'image/gif, image/jpeg, image/png, image/jpg',
                tagPostParams: {
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: '3'
                },
                tagList: [],
                activeNames: '',
                allTags: true,
                tagVisitorPostParams: {
                    tagId: '',
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: '3'
                },
                currentActiveChildren: []
            }
        },
        components: {
            VueEmoji
        },
        created() {


        },
        mounted() {
            this.getVisitorList()
            let _this = this
            document.addEventListener('click', function () {
                _this.showEmoji = false
            })
        },
        watch: {
            'dialogVisible': {
                handler(val) {
                    if (val) {
                        this.initData()
                        this.getVisitorList()
                    }
                },
                deep: true
            }
        },
        methods: {
            clickEmoji() {
                this.showEmoji = !this.showEmoji
            },
            /**
             * <vue-emoji></vue-emoji>
             * @/libs/emoji
             * @/components/emoji/Emoji
             * 选中emoji
             */
            selectEmoji(emoji) {
                this.$refs.textContentInput.$el.childNodes[0].focus()
                this.$nextTick(() => {
                    const newEmoji = "[" + emoji.value[0] + "]"
                    this.showEmoji = false

                    this.insertHtmlAtCaret(this.$refs.textContentInput.$el.childNodes[0], newEmoji)
                    this.$nextTick( () => {
                        console.log('this.$refs.textContentInput=',this.$refs.textContentInput)
                    })
                })
            },
            /**
             * Author: brand
             * Creation Time: 2019-05-07 09:10
             * Description: 光标处插入消息
             */
            insertHtmlAtCaret(myField, myValue) {
                //IE support
                if (document.selection) {
                    myField.focus();
                    sel = document.selection.createRange();
                    sel.text = myValue;
                    sel.select();
                }
                //MOZILLA/NETSCAPE support
                else if (myField.selectionStart || myField.selectionStart == '0') {
                    var startPos = myField.selectionStart;
                    var endPos = myField.selectionEnd;
                    // save scrollTop before insert
                    var restoreTop = myField.scrollTop;
                    myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);

                    this.textContent = myField.value
                    if (restoreTop > 0) {
                        // restore previous scrollTop
                        myField.scrollTop = restoreTop;
                    }
                    myField.focus();
                    myField.selectionStart = startPos + myValue.length;
                    myField.selectionEnd = startPos + myValue.length;
                } else {
                    myField.value += myValue;
                    this.textContent = myField.value
                    myField.focus();
                }
            },
            TplClickEmoji(event) {
                event.stopPropagation()
            },
            getVisitorList() {
                let postData = {
                    sourceQk: this.channel,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
                this.loadingData = true
                this.$http.getMassVisitorListAPI(postData).then(res => {
                    this.loadingData = false
                    if (res.status == 1) {
                        this.visitorData = this.visitorData.concat(res.data.list)
                        if (res.data.list.length < postData.pageSize) {
                            this.isFinished = true
                        } else {
                            this.isFinished = false
                        }
                    }
                }).catch(() => {
                    this.loadingData = false
                })
            },
            initData() {
                this.channel = '3'
                this.pageNum = 1
                this.checkAll = false
                this.pageSize = 10
                this.checkedVisotors = []
                this.checkedVisotorsItem = []
                this.visitorData = []
                this.textContent = ''
                this.imgContent = ''
                this.tabChange = 'visitor'
                this.tagPostParams = {
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: '3'
                }
                this.tagList = []
                this.activeNames = ''
                this.allTags = true
                this.tagVisitorPostParams = {
                    tagId: '',
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: '3'
                }
                this.currentActiveChildren = []
            },
            sendMassMsg() {
                if (this.checkedVisotors.length === 0) {
                    this.$message({
                        showClose: true,
                        message: '请先选择访客',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                if (this.textContent.trim().length === 0 && this.imgContent.trim().length === 0) {
                    this.$message({
                        showClose: true,
                        message: '请填写消息内容',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                let nickNameArr = []
                this.checkedVisotorsItem.map((item) => {
                    nickNameArr.push(item.visitorName)
                })
                let postText = this.textContent
                let partten = /\[(.+?)\]/g
                if (this.textContent.match(partten)) {
                    this.textContent.match(partten).map(item => {
                        for (let key in emojiData) {
                            let emojiCN = '[' + emojiData[key][0] + ']'
                            let emojiEN = ':' + key + ':'
                            let reg = new RegExp("\\[(" + emojiData[key][0] + ")\\]", "ig")
                            if (item == emojiCN) {
                                postText = postText.replace(new RegExp(reg, "g"), emojiEN)
                            }
                        }
                    })
                }
                let postParams = {
                    textContent: postText,
                    sourceQk: this.channel,
                    imgContent: this.imgContent,
                    visitorIds: this.checkedVisotors,
                    recipient: nickNameArr.join('、'),
                }
                this.$http.sendMassMsgAPI(postParams).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.$emit('closeDialog')
                        this.initData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        })
                    }
                })
            },
            uniqueArray(array, key){
                var result = [array[0]];
                for(var i = 1; i < array.length; i++){
                    var item = array[i];
                    var repeat = false;
                    for (var j = 0; j < result.length; j++) {
                        if (item[key] == result[j][key]) {
                            repeat = true;
                            break;
                        }
                    }
                    if (!repeat) {
                        result.push(item);
                    }
                }
                return result;
            },
            delImage() {
                this.imgContent = ''
            },
            chooseImage() {
                this.$refs.imageFileChange.click()
            },
            imageFileChange(e) {
                let img = e.target.files[0]
                let type = img.type
                let size = img.size
                if (this.accept.indexOf(type) == -1) {
                    this.$message({
                        showClose: true,
                        message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                if (size > 5242880) {
                    this.$message({
                        showClose: true,
                        message: '请选择5M以内的图片！',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return false
                }
                let formdata = new FormData()
                formdata.set('file', img)

                this.$http.uploadImageAPI(formdata).then(res => {
                    if (res.status == 1) {
                        console.log('img-res===', res)
                        this.imgContent = res.data
                        this.$refs.imageFileChange.value = ''
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    }
                }).catch(error => {
                    this.$refs.imageFileChange.value = ''
                    this.$message({
                        message: '图片 上传失败，请重试！',
                        type: 'error',
                    })
                })
            },
            changeChannel() {
                this.tabChange = 'visitor'
                this.pageNum = 1
                this.pageSize = 10
                this.checkAll = false
                this.checkedVisotors = []
                this.checkedVisotorsItem = []
                this.visitorData = []
                this.tagPostParams = {
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: this.channel
                }
                this.tagList = []
                this.activeNames = ''
                this.allTags = true
                this.tagVisitorPostParams = {
                    tagId: '',
                    pageNum: 1,
                    pageSize: 10,
                    sourceQk: this.channel
                }
                this.currentActiveChildren = []
                this.getVisitorList()

            },
            loadMoreData(e) {
                if (!this.isFinished) {
                    this.pageNum++
                    this.getVisitorList()
                }
            },
            handleCheckAllChange(val) {
                if (val) {
                    this.visitorData.map((item) => {
                        this.checkedVisotors.push(item.visitorId)
                    })
                    this.checkedVisotors = Array.from(new Set(this.checkedVisotors));
                    this.checkedVisotorsItem = this.compareArr(this.checkedVisotors, this.visitorData)
                } else {
                    this.checkedVisotors = []
                    this.checkedVisotorsItem = []
                }
            },
            handleCheckedVisitorChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.visitorData.length;
                this.checkedVisotorsItem = this.compareArr(value, this.visitorData)
            },
            compareArr(arr1, arr2) {
                return arr1.map(item1 => {
                    return arr2.find(item2 => item2.visitorId === item1) || {}
                })
            },
            handleTagCheckAllChange (val) {
                if (val) {
                    console.log('this.currentActiveChildren=',this.currentActiveChildren)
                    this.currentActiveChildren.map((item) => {
                        this.checkedVisotors.push(item.visitorId)
                    })
                    this.checkedVisotors = Array.from(new Set(this.checkedVisotors));
                    this.checkedVisotorsItem = this.compareArr(this.checkedVisotors, this.currentActiveChildren)
                } else {
                    this.checkedVisotors = []
                    this.checkedVisotorsItem = []
                }
            },
            handleCheckedTagVisitorChange(value) {
                let checkedCount = value.length;
                console.log(value)
                this.tagList.map((item) => {
                    if (item.id == this.tagVisitorPostParams.tagId) {
                        item.checkAll = checkedCount === this.currentActiveChildren.length;
                    }
                })
                // this
                this.checkedVisotorsItem = this.compareArr(value, this.currentActiveChildren)
            },
            avatarX(avatar) {
                let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, 'g')
                if (reg.test(avatar)) {
                    return avatar;
                } else {
                    const img = avatar.substring(avatar.length - 5, avatar.length - 4)
                    switch (img) {
                        case 'y':
                            return avatar0
                            break
                        case '1':
                            return avatar1
                            break
                        case '2':
                            return avatar2
                            break
                        case '3':
                            return avatar3
                            break
                        case '4':
                            return avatar4
                            break
                        case '5':
                            return avatar5
                            break
                        case '6':
                            return avatar6
                            break
                        case '7':
                            return avatar7
                            break
                        default:
                            return avatar
                            break
                    }
                }
            },
            loadTags() {
                this.loadingData = true
                this.$http.getMassTagListAPI(this.tagPostParams).then(res => {
                    this.loadingData = false
                    if (res.status == 1) {
                        let list = res.data
                        list.map((item) => {
                            // item.children = []
                            item.noMoreData = true
                            item.pageNum = 1
                            item.checkAll = false
                        })
                        if (list.length < this.tagPostParams.pageSize) {
                            this.allTags = true
                        } else {
                            this.allTags = false
                        }
                        this.tagList = this.tagList.concat(list)
                    }
                    console.log('tag-list===', this.tagList)
                }).catch(() => {
                    this.loadingData = false
                })
            },
            tabChangeHandler(data) {
                this.tabChange = data
                this.checkedVisotors = []
                this.checkedVisotorsItem = []
                if (data === 'tag' && this.tagList.length === 0) {
                    this.loadTags()
                }
            },
            loadMoreTag() {
                this.tagPostParams.pageNum++
                this.loadTags()
            },
            loadVisitorByTag() {
                this.loadingData = true
                this.$http.getMassVisitorByTagAPI(this.tagVisitorPostParams).then(res => {
                    this.loadingData = false
                    if (res.status == 1) {
                        let tagVisitor = res.data.list
                        this.tagList.map((item) => {
                            if (item.id == this.tagVisitorPostParams.tagId) {
                                item.children = item.children.concat(tagVisitor)
                                this.currentActiveChildren = item.children
                                if (tagVisitor.length < this.tagVisitorPostParams.pageSize) {
                                    item.noMoreData = true
                                } else {
                                    item.pageNum++
                                    item.noMoreData = false
                                }
                            }
                        })
                    }
                }).catch(() => {
                    this.loadingData = false
                })
            },
            loadMoreVisitorData(val, pageNum) {
                console.log('val==', val)
                console.log('pageNum==', pageNum)
                this.tagVisitorPostParams.tagId = val
                this.tagVisitorPostParams.pageNum = pageNum
                this.loadVisitorByTag()
            },
            collapseChange(val) {
                this.checkedVisotors = []
                this.checkedVisotorsItem = []
                this.tagVisitorPostParams.tagId = val
                this.tagList.map((item) => {
                    item.checkAll = false
                    // if (item.id == val && item.children.length === 0) {
                    //     this.tagVisitorPostParams.pageNum = item.pageNum
                    //     // this.loadVisitorByTag()
                    // }
                    if (item.id == val) {
                        console.log('item.children=',item.children)
                        this.tagVisitorPostParams.pageNum = item.pageNum
                        this.currentActiveChildren = item.children
                    }
                })

            }
        }
    }
</script>

<style lang="scss">
    .newMass {
        .mass-channel-conntainer {
            display: flex;

            .channel-label {
                width: 100px;
            }

            .channal-list {
                flex: 1;
            }
        }

        .dialog-container {
            display: flex;
            margin-top: 15px;
            box-sizing: border-box;
            height: 500px;
            border: 1px solid #eee;
            border-radius: 4px;
            overflow: hidden;
            position: relative;

            .visitor-list-container, .visitor-chose-container {
                width: 260px;
                height: 100%;
                overflow-y: auto;
            }

            .visitor-sendMsg-contianer {
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;

                .content-container {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    & > div {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 15px;
                        box-sizing: border-box;
                    }

                    .text-msg {
                        position: relative;

                        .text-emoji {
                            position: absolute;
                            top: 55px;
                        }

                        .chat-bar-icon {
                            margin-top: 2px;
                            cursor: pointer;
                        }

                        .textMsgInput {
                            display: block;
                            margin-top: 8px;
                            height: 160px;

                            textarea {
                                resize: none;
                                height: 100%;
                            }
                        }
                    }

                    .image-msg {
                        border-top: 1px solid #eee;
                        border-bottom: 1px solid #eee;
                        box-sizing: border-box;

                        .choose-image {
                            background-color: #9b9b9b;
                            color: #fff;
                            padding: 8px 10px;
                            box-sizing: border-box;
                            border-radius: 4px;
                            cursor: pointer;
                        }

                        .img-wraper {
                            width: 150px;
                            height: 150px;
                            margin: 17px auto 0;
                            border: 1px solid #eee;
                            border-radius: 4px;
                            padding: 15px;
                            box-sizing: border-box;
                            position: relative;

                            .del-btn {
                                position: absolute;
                                top: -8px;
                                right: -8px;
                                font-size: 20px;
                                cursor: pointer;
                            }

                            img {
                                max-width: 100%;
                                max-height: 100%;
                            }
                        }
                    }
                }

                .send-operation {
                    text-align: right;
                    height: 50px;

                    span {
                        margin-right: 15px;
                        margin-top: 5px;
                    }
                }
            }

            .visitor-list-container {
                background-color: rgb(235, 235, 235);
                padding: 10px 8px 8px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .list-wrapper {
                    flex: 1;
                    overflow-y: scroll;

                    .el-collapse {
                        border: none;
                    }

                    .el-collapse-item__header, .el-collapse-item__content {
                        background: #ebebeb;
                        border-bottom: none;
                    }

                    .tagItem {
                        position: relative;

                        .checkbox-list {
                            margin-top: 0;
                        }

                        .el-collapse-item__wrap {
                            padding-top: 22px;
                            background-color: #ebebeb;
                        }
                        &.pd0{
                            .el-collapse-item__wrap {
                                padding-top: 0px;
                            }
                        }

                        .el-collapse-item__content {
                            max-height: 300px;
                            overflow-y: auto;
                            padding-bottom: 0;
                        }
                    }

                }

                .tab-btn-wraper {
                    height: 30px;
                    text-align: center;

                    .tab-btn-container {
                        background-color: #fff;
                        border-radius: 4px;
                        display: inline-block;

                        .tab-btn {
                            padding: 6px 14px;
                            font-size: 12px;
                            cursor: pointer;
                            box-sizing: border-box;
                            display: inline-block;

                            &.activeBtn {
                                background-color: #3a8ee6;
                                color: #fff;
                                border-radius: 4px;
                            }
                        }
                    }
                }

                .checkAll-btn {
                    position: absolute;
                    top: 40px;
                    left: 0px;
                    width: 260px;
                    height: 30px;
                    z-index: 99;
                    background-color: rgb(235, 235, 235);
                    color: #fff;
                    padding: 4px 0 0 8px;
                    box-sizing: border-box;
                }

                .checkbox-list {
                    display: flex;
                    flex-direction: column;
                    margin-top: 45px;

                    .visitor-list-item + .visitor-list-item {
                        margin-top: 10px;
                    }

                    .visitor-list-item {
                        display: flex;
                        line-height: 30px;
                        margin-right: 0;
                        overflow: hidden;
                        align-items: center;

                        .el-checkbox__label {
                            display: flex;
                            width: 100%;
                        }

                        .visitor-info-container {
                            display: flex;
                            overflow: hidden;
                            align-items: center;

                            .visitor-avatar {
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                overflow: hidden;

                                img {
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 50%;
                                }
                            }

                            .visitor-nickname {
                                flex: 1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                padding: 0 8px;
                                box-sizing: border-box;
                            }
                        }
                    }
                }

                .loadmore-data {
                    padding: 10px;
                    box-sizing: border-box;
                    text-align: center;

                    span {
                        font-size: 12px;

                        &.hava-more {
                            cursor: pointer;
                        }
                    }
                }
            }

            .visitor-chose-container {
                border-right: 1px solid #eee;
                border-left: 1px solid #eee;
                padding: 15px;
                box-sizing: border-box;

                .choose-item {
                    width: 33.333%;
                    float: left;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 10px;
                    align-items: center;
                    overflow: hidden;

                    .choose-avatar {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .choose-nickname {
                        width: 100%;
                        padding: 5px 5px 0;
                        box-sizing: border-box;
                        font-size: 12px;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
</style>